import { useEffect } from 'react';
import { QueryKey, useQueryClient } from 'react-query';
import { matchQuery } from 'utils/queryClient';
import { protectQueryAction } from 'utils/typeGuards';

/**
 * @param queryKey - query key from useQuery hook
 * @param callback - function that will be called when the data is updated
 * @example
 * useSubscribeUpdate(queryKey, form.reset);
 */
export const useSubscribeUpdate = <T>(
  queryKey: QueryKey,
  callback: (data: T | undefined) => void,
): void => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe((query) => {
      const matchAuthUserQuery =
        query && query.type === 'queryUpdated' && matchQuery({ queryKey }, query.query);

      if (matchAuthUserQuery && protectQueryAction<T>(query.action))
        callback(query.action.data);
    });

    return () => {
      unsubscribe();
    };
  }, []);
};
